import { render, staticRenderFns } from "./ques-result.vue?vue&type=template&id=0c9ca0eb&scoped=true&"
import script from "./ques-result.vue?vue&type=script&lang=js&"
export * from "./ques-result.vue?vue&type=script&lang=js&"
import style0 from "./ques-result.vue?vue&type=style&index=0&id=0c9ca0eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ca0eb",
  null
  
)

export default component.exports